export default "__VITE_ASSET__0d73e770__"